import { centerListingConstant, globalConstants } from "../../constants";

//-------initial state for center listing reducer
const initialState = {
  centerListingData: { page: {}, pageData: [] },
  centerSpotListingData: { page: {}, pageData: [] },
  centerProfileData: null,
  centerInstructors: { page: {}, pageData: [] },
  centerActivities: { page: {}, pageData: [] },
};

//-------center listing reducer
const centerListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case centerListingConstant.GET_ALL_APPROVED_CENTERS_LIST +
      globalConstants.SUCCESS:
      return {
        ...state,
        centerListingData: action.data,
      };
    case centerListingConstant.GET_CENTER_PROFILE_DATA_BY_ID +
      globalConstants.SUCCESS:
      return {
        ...state,
        centerProfileData: action.data,
      };
    case centerListingConstant.GET_CENTER_PROFILE_DATA_BY_ID +
      globalConstants.FAILURE:
      return {
        ...state,
        centerProfileData: action.data,
      };
    case centerListingConstant.GET_ALL_CENTER_INSTRUCTORS_LIST +
      globalConstants.SUCCESS:
      return {
        ...state,
        centerInstructors: action.data,
      };
    case centerListingConstant.GET_ALL_CENTER_ACTIVITIES +
      globalConstants.SUCCESS:
      return {
        ...state,
        centerActivities: action.data,
      };
    case centerListingConstant.GET_ALL_APPROVED_CENTERS_LIST_BY_SPOTID +
      globalConstants.SUCCESS:
      return {
        ...state,
        centerSpotListingData: action.data,
      };
    default:
      return state;
  }
};

//-------export center listing reducer
export default centerListingReducer;
